export default function SuggestionChips({ suggestions, onPick }) {
  return (
    <div className="px-4 pb-2 flex flex-wrap gap-2">
      {suggestions.map((s) => (
        <button
          key={s}
          data-testid={`chat-suggestion-${s.slice(0, 12)}`}
          onClick={() => onPick(s)}
          className="text-[11px] font-mono-tactical uppercase tracking-wider px-2 py-1 border border-white/15 text-zinc-300 hover:border-[#7CFF00] hover:text-[#7CFF00]"
        >
          {s}
        </button>
      ))}
    </div>
  );
}
